import gql from "graphql-tag";
import { RebateFragment } from "../fragments/rebate.fragment";

export const CALCULATE_WEEKLY_REBATES = gql`
  mutation ($input: CalculateWeeklyRebatesInput!) {
    calculateWeeklyRebates(input: $input) {
      ...Rebate
    }
  }
  ${RebateFragment}
`;
